export default __webpack_public_path__ + "static/media/icon-search.2b25cccd.svg";